import { render, staticRenderFns } from "./AppDrawerClientes.vue?vue&type=template&id=1040d6f5&scoped=true&"
import script from "./AppDrawerClientes.vue?vue&type=script&lang=js&"
export * from "./AppDrawerClientes.vue?vue&type=script&lang=js&"
import style0 from "./AppDrawerClientes.vue?vue&type=style&index=0&id=1040d6f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1040d6f5",
  null
  
)

export default component.exports